import { render } from "./report_report_component.vue?vue&type=template&id=24f4a71a&scoped=true"
import script from "./report_report_component.vue?vue&type=script&scoped=true&lang=js"
export * from "./report_report_component.vue?vue&type=script&scoped=true&lang=js"

import "./report_report_component.vue?vue&type=style&index=0&id=24f4a71a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f4a71a"]])

export default __exports__